import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { SelectField } from '@/components/functional/Form/SelectField';
import { DatePickerField } from '@/components/ui/Form/DatePickerField';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { hotlineChangeScheduleFieldStyle } from '@/feature/hotline/component/HotlineChangeScheduleField/style';
import { FIELD_DOM_CLASS_NAME } from '@/utils/form/scroll';
/**
 * 匿名コンサルホットライン 日付入力 Field
 */
export const HotlineChangeScheduleField = (props) => {
    const { className = '', dateFieldName, datePopperClassName, timeFieldName, } = props;
    const minTime = useMemo(() => {
        const now = new Date();
        const hours = now.getHours();
        // 現在の分が 0〜29分の場合は次の 30分, 30〜59分の場合は次の 00分（+1時間）
        const nextMinutes = now.getMinutes() < 30 ? 30 : 0;
        const nextHours = nextMinutes === 0 ? hours + 1 : hours;
        // 今日の最小の日時を取得（30分区切り）
        const min = new Date(now.getFullYear(), now.getMonth(), now.getDate(), nextHours, nextMinutes, 0, 0);
        return min;
    }, []);
    /** 日付選択のフィルター（過去の日程を非活性にする） */
    const filterTime = useCallback((date) => {
        const isPastTime = new Date().getTime() > date.getTime();
        return !isPastTime;
    }, []);
    const style = hotlineChangeScheduleFieldStyle();
    return (_jsxs("div", Object.assign({ className: style.base({ class: className }) }, { children: [_jsxs("div", Object.assign({ className: style.field({ class: FIELD_DOM_CLASS_NAME }) }, { children: [_jsx(FieldLabel, { className: style.labelText(), htmlFor: dateFieldName, labelText: '相談開始日時' }), _jsx(DatePickerField, { dateFormat: 'yyyy/MM/dd HH:mm', filterTime: filterTime, id: dateFieldName, minDate: minTime, name: dateFieldName, popperClassName: datePopperClassName, showTimeSelect: true })] })), _jsxs("div", Object.assign({ className: style.field({ class: FIELD_DOM_CLASS_NAME }) }, { children: [_jsx(FieldLabel, { className: style.labelText(), htmlFor: timeFieldName, labelText: '相談時間の指定' }), _jsx(SelectField, { ellipsis: false, id: timeFieldName, isNumberValue: true, name: timeFieldName, options: Array.from({ length: 5 }, (_, i) => ({
                            label: `${i + 1}時間`,
                            value: i + 1,
                        })), placeholder: '選択してください' })] }))] })));
};
